import { RecordType } from 'app/constants/GlobalTypes'
import rentalNormalizer from 'app/lib/apollo/normalizers/Rental'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import { useQuery } from 'app/lib/hooks/useQuery'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as rentalsCheckout from 'app/queries/Rentals/Checkout'
import { uniqueId } from 'lodash'
import { ComponentProps } from 'react'

import { CheckoutFooter } from '../../Checkout/Footer'
import DeliveryAddressForm from '../../DeliveryAddress/Form'

const useDeliveryAddressForm = (rental_id?: string) => {
  const { tComponent } = useTranslation({
    componentType: 'feedback',
    scope: 'drawer.title',
    recordType: RecordType.delivery_address
  })
  const { drawerfy } = useFeedbacker()
  const {
    data: { rental },
    loading
  } = useQuery<{ rental: IRental }>(rentalsCheckout.RENTAL_CHECKOUT_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-first',
    skip: !rental_id,
    variables: {
      id: rental_id
    },
    normalizer: (data) => ({ rental: rentalNormalizer(data.rental) })
  })

  const openDrawer = ({
    member,
    props: {
      formProps: { onSuccess: onSuccessParent, ...otherFormProps } = {},
      addressInputProps = {},
      allowProjectSelection = true
    } = {}
  }: Partial<ComponentProps<typeof DeliveryAddressForm>>) => {
    const addressPortalId = uniqueId('kfooter-address')
    const onAddressSave = () => {
      drawerfy.closeAll()
      onSuccessParent?.(rental)
    }

    drawerfy.open({
      content: (
        <DeliveryAddressForm
          props={{
            formProps: {
              ...otherFormProps,
              onSuccess: onAddressSave,
              loading,
              portalId: addressPortalId
            },
            addressInputProps: {
              initialDeliveryZip: addressInputProps.showAvailabilityHint
                ? rental.deliveryAddress?.zip
                : undefined,
              ...addressInputProps
            },
            allowProjectSelection
          }}
          member={{ ...rental, ...member }}
        />
      ),
      title: tComponent({ id: 'update' }),
      drawerType: 'page',
      footer: <CheckoutFooter id={addressPortalId} />,
      closable: false,
      width: 600
    })
  }

  return { open: openDrawer, close: drawerfy.close }
}

export default useDeliveryAddressForm
